<div class="system-message-container">
  <div class="section-header">
    <h1>System Message Board Maintenance</h1>
  </div>

  <!-- Success message shown after update -->
  <div class="success-message" *ngIf="showSuccessMessage">
    The item has been successfully Updated.
  </div>

  <div class="section-content">
    <div class="form-row">
      <div class="label">Facility:</div>
      <div class="text-field">
        ES
      </div>
    </div>

    <div class="form-row">
      <div class="label">Message Board:</div>
      <div class="input-field">
        <textarea pInputTextarea [(ngModel)]="messageBoard" rows="5" autoResize="true"></textarea>
      </div>
    </div>
  </div>

  <div class="section-footer">
    <p-button label="Update System Message Board" (click)="updateSystemMessage()" class="btn-primary"></p-button>
  </div>

  <div class="page-footer">
    <div class="footer-text">
      Last Update: {{ lastUpdateDate | date:'EEEE, MMMM d, y' }} | © 2006-2025 Chevron Corporation | Company Confidential | Opco: Downstream & Chemicals
    </div>
  </div>
</div>
